import util from './_utils';
import lang from './lang';

let html,
	filters = false;

function init() {
	const button_about = d3.selectAll('.header-button-about'),
		button_about_close = d3.selectAll('.close-button-about');

	const button_menu = d3.selectAll('.header-button-menu'),
		button_menu_close = d3.selectAll('.close-button-menu');

	const button_language = d3.selectAll('.button-container-filters'),
		button_language_close = d3.selectAll('.header-button-language-close'),
		button_menu_change_language = d3.selectAll('.page--menu__content__footer--change-language');

	const button_personalize = d3.selectAll('.header-button-personalize'),
		button_personalize_close = d3.selectAll('.header-button-personalize-close');

	const wordmark = d3.selectAll('.strava-wordmark');

	button_about.on('click', () => toggleAbout(true));
	button_about_close.on('click', () => toggleAbout(false))

	button_menu.on('click', () => {
		toggleMenu(true);
		toggleLanguage(false);
		toggleAbout(false);
	});
	button_menu_close.on('click', () => toggleMenu(false))

	button_language.on('click', () => {
		toggleLanguage(true)
		toggleAbout(false);
	});
	button_language_close.on('click', () => toggleLanguage(false));
	button_menu_change_language.on('click', () => {
		toggleLanguage(true);
		toggleMenu(false);
	});

	button_personalize.on('click', () => togglePersonalize(!filters));
	button_personalize_close.on('click', () => {
		d3.selectAll('.personalize-button-tooltip').classed('is-visible', false);
		togglePersonalize(false)
	});

	wordmark.attr('href', () => {
		const currentLang = lang.getCurrentLang() == 'en-US' ? '?lang=en-EN' : `?lang=${lang.getCurrentLang()}`
		return currentLang;
	})

	resize();
}

function resize() {
	const header_width = d3.select('.viz-header').node().offsetWidth;

	const bottom_panel = d3.select('.graphic__chart .bottom__panel');
	bottom_panel.style('width', `${header_width}px`)
		.style('top', '100%');

	const top_panel = d3.selectAll('.graphic__chart .top-panel');
	top_panel.style('width', `${header_width}px`);

	const personalize_panel = d3.select('.page--personalize');
	personalize_panel.style('width', `${header_width}px`);

	const cv_dropdown = d3.select('.cv-dropdown');
	cv_dropdown.style('left', `${header_width / 2}px`)

	if (util.isMobile()) {
		const windowH = window.innerHeight;
		const panel_height = d3.select('.graphic__right.core-viz').node().offsetHeight;

		// bottom_panel.style('top', `${windowH - panel_height}px`)
		bottom_panel.style('top', `50%`).style('transform', 'translate(0, -100%)')
	}
}

function toggleMenu(show) {
	util.changeVisibility(['.page--menu'], [show]);
}

function toggleLanguage(show) {
	util.changeVisibility(['.page--language', '.header-button-language .button-container-filters', '.header-button-language-close', '.header-button-personalize', '.header-button-personalize-close'], [show, show ? false : true, show ? true : false, !show]);
}

function toggleAbout(show) {
	util.changeVisibility(['.page--about'], [show]);
}

function togglePersonalize(show) {
	util.changeVisibility(['.page--personalize', '.header-button-personalize', '.header-button-personalize-close'], [show, !show, show]);

	filters = show;

	if (util.isMobile()) {
		d3.selectAll('.graphic, .personalize-button-tooltip').on('click', () => {
			togglePersonalize(false);
		});
	}
}

function toggleFilters(status = false) {
	filters = status;
}

export default {
	init,
	toggleAbout,
	toggleMenu,
	toggleFilters,
	toggleLanguage,
	togglePersonalize,
	resize
}